var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleTick = function SvgCircleTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11zm0-2c4.97 0 9-4.03 9-9s-4.03-9-9-9-9 4.03-9 9 4.03 9 9 9zm-2.765-9.178l1.51 1.635 3.967-5.073c.34-.435.969-.512 1.404-.172.435.34.512.969.172 1.404l-4.693 6c-.38.486-1.104.515-1.522.062l-2.308-2.5c-.374-.406-.35-1.038.057-1.413.406-.374 1.038-.35 1.413.057z"
  })));
};
export default SvgCircleTick;